<div class="box box-primary grid">
  <div class="content col-12">
    <div class="grid lg:col-12 md:col-12 sm:col-12">

      <div class="grid lg:col-5 md:col-12 sm:col-12  align-content-center justify-content-around align-items-center m-1 p-1">

        <label class="lg:col-6 md:col-6 sm:col-6 text-2xl font-semibold text-700"
          >{{ 'Nombre' | translate }}:
        </label>
        <div class="lg:col-6 md:col-6 sm:col-6">
          <label class="text-xl font-medium text-500">{{ Location?.display_name }}</label>
        </div>

      </div>

      <div class="grid lg:col-5 md:col-12 sm:col-12 align-content-center justify-content-around align-items-center m-1 p-1">
        <label class="lg:col-6 md:col-6 sm:col-12  text-2xl font-semibold text-700"
          >{{ 'Tipo' | translate }}:</label
        >
        <div class="lg:col-6 md:col-6 sm:col-12">
          <label class="text-xl font-medium text-500">{{ Location?.type?.name }}</label>
        </div>
      </div>

      <hr class="lg:col-12 md:col-12 sm:col-12" />

      <div class="grid  lg:col-5 md:col-12 sm:col-12 align-content-center justify-content-around align-items-center m-1 p-1">
        <label class="lg:col-6 md:col-6 sm:col-12  text-2xl font-semibold text-700"
          >{{ 'Creado Por' | translate }}
        </label>
        <div class="lg:col-6 md:col-6 sm:col-12">
          <label class="text-xl font-medium text-500">{{ Location?.created_by?.username }}</label>
        </div>
      </div>
      <div class="grid  lg:col-5 md:col-12 sm:col-12 align-content-center justify-content-around align-items-center m-1 p-1">
        <label class="lg:col-6 md:col-6 sm:col-12  text-2xl font-semibold text-700"
          >{{ 'Fecha de creación' | translate }}:</label
        >
        <div class="lg:col-6 md:col-6 sm:col-12">
          <label class="text-xl font-medium text-500">{{ Location?.created }}</label>
        </div>
      </div>

      <hr class="lg:col-12 md:col-12 sm:col-12" />

      <div class="grid  lg:col-5 md:col-12 sm:col-12 align-content-center justify-content-around align-items-center m-1 p-1"
        *ngIf="Location?.external_id"
      >
        <label class="lg:col-6 md:col-6 sm:col-12  text-2xl font-semibold text-700"
          >{{ 'External ID' | translate }}:</label
        >
        <div class="lg:col-6 md:col-6 sm:col-12">
          <label class="text-xl font-medium text-500">{{ Location?.external_id }}</label>
        </div>
      </div>
      <div class="grid  lg:col-5 md:col-12 sm:col-12 align-content-center justify-content-around align-items-center m-1 p-1"
        *ngIf="Location?.description"
      >
        <label class="lg:col-6 md:col-6 sm:col-12  text-2xl font-semibold text-700">{{
          'Descripcion' | translate
        }}</label>
        <div class="lg:col-6 md:col-6 sm:col-12">
          <label class="text-xl font-medium text-500">{{ Location?.description }}</label>
        </div>
      </div>

      <hr class="lg:col-12 md:col-12 sm:col-12" />

      <div class="grid  lg:col-5 md:col-12 sm:col-12 align-content-center justify-content-around align-items-center m-1 p-1">
        <label class="lg:col-6 md:col-6 sm:col-12  text-2xl font-semibold text-700">{{
          'Pertenece a' | translate
        }}</label>
        <div class="lg:col-6 md:col-6 sm:col-12">
          <label class="text-xl font-medium text-500">{{ Location?.parent?.display_name }}</label>
        </div>
      </div>

    </div>
  </div>
</div>
